import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Panel from "@components/panel";
import UserDashboard from "@userPanel/dashboard";
import Auth from "@auth";
import GuestLayout from "@layouts/GestLayout";
import AuthedLayout from "@layouts/AuthedLayout";
import NotFound from "@general/notFound";
import NotAllowed from "@general/notAllowed";
import Profile from "@userPanel/profile";
import UserServices from "@userPanel/services";
import UserTransactions from "@userPanel/transactions";
import UsersInvoices from "@userPanel/invoices";
import AdminDashboard from "@adminPanel/dashboard";
import AdminUsers from "@adminPanel/users";
import AdminAllUsersTransactions from "@adminPanel/transactions";
import AdminAllUsersInvoices from "@adminPanel/invoices";
import AdminAllUsersCards from "@adminPanel/cards";
import AdminCoreServices from "@adminPanel/coreServices";
import AddCoreService from "@adminPanel/coreServices/addCoreService";
import AdminPackages from "@adminPanel/packages";
import AdminCalendar from "@adminPanel/calendar";
import AddPackage from "@adminPanel/packages/addPackage";
import UsersPurchases from "@adminPanel/purchases";
import AdminAccounting from "@adminPanel/accounting";
import Holidays from "@adminPanel/holidays";
import AdminConsultation from "@adminPanel/consultations";
import OtherErrors from "@general/otherErrors";
import "./App.less";
import Setting from "@userPanel/setting";
import PayInvoice from "@general/userPayment";
import AdminSettings from "@adminPanel/setting";
import UserPaymentResult from "@general/userPayment/paymentResult";
import Discounts from "@adminPanel/discounts";
import UserHoliday from "@userPanel/services/singleServices/holiday";
import PackageServices from "@userPanel/services/packageServices";
import UserConsulting from "@userPanel/services/singleServices/consultations";
import WsSinglePackage from "@userPanel/services/packageServices/workSpace/wsSingle";
import MtSinglePackage from "@userPanel/services/packageServices/meetingRoom/mtSingle";
import EventsSingle from "@userPanel/services/singleServices/events/singleEvenets";
import ClassesSingle from "@userPanel/services/singleServices/classes/singleClasses";
import SingleConsultation from "@userPanel/services/singleServices/consultations/singleConsultation";
import BthDayMessage from "@adminPanel/messages/bthDayMessage";
import AdminMessages from "@adminPanel/messages";
import AddMessage from "@adminPanel/messages/addMessage";
import NotificationList from "@userPanel/notifications";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<GuestLayout />}>
            <Route path="/login" element={<Auth />} />
          </Route>

          <Route element={<AuthedLayout />}>
            <Route element={<Panel allowedRole="USER" />}>
              <Route path="dashboard" element={<UserDashboard />} />
              <Route path="profile" element={<Profile />} />
              <Route path="services" element={<UserServices />} />
              <Route path="notifications" element={<NotificationList />} />
              <Route path="services/holiday" element={<UserHoliday />} />
              <Route path="services/consulting" element={<UserConsulting />} />
              <Route
                path="services/consultation-single/:id"
                element={<SingleConsultation />}
              />
              <Route
                path="services/work-spaces"
                element={<PackageServices />}
              />
              <Route
                path="services/meeting-rooms"
                element={<PackageServices />}
              />
              <Route
                path="services/workspace-single/:id"
                element={<WsSinglePackage />}
              />
              <Route
                path="services/meeting-room-single/:id"
                element={<MtSinglePackage />}
              />
              <Route
                path="events/events-single/:id"
                element={<EventsSingle />}
              />
              <Route
                path="classes/classes-single/:id"
                element={<ClassesSingle />}
              />
              <Route path="transactions" element={<UserTransactions />} />
              <Route path="invoices" element={<UsersInvoices />} />
              <Route path="setting/:target" element={<Setting />} />
              <Route path="invoice/:invoiceId" element={<PayInvoice />} />
              <Route path="payment-result" element={<UserPaymentResult />} />
            </Route>
            <Route element={<Panel allowedRole="ADMIN" />}>
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route path="/admin-users" element={<AdminUsers />} />
              <Route path="/admin-messages" element={<AdminMessages />} />
              <Route path="/admin-messages/add-message" element={<AddMessage />} />
              <Route path="/admin-messages/birthday" element={<BthDayMessage />} />

              <Route
                path="admin-transactions/:result"
                element={<AdminAllUsersTransactions />}
              />
              <Route path="admin-accounting" element={<AdminAccounting />} />
              <Route path="admin-calendar" element={<AdminCalendar />} />
              <Route path="admin-consultations/:result" element={<AdminConsultation />} />
              <Route
                path="admin-invoices/:result"
                element={<AdminAllUsersInvoices />}
              />
              <Route
                path="admin-cards/:result"
                element={<AdminAllUsersCards />}
              />

              <Route path="admin-discounts" element={<Discounts />} />
              <Route path="admin-holidays" element={<Holidays />} />
              <Route
                path="admin-purchases/:result"
                element={<UsersPurchases />}
              />
              <Route path="admin-packages/" element={<AdminPackages />} />
              <Route
                path="admin-packages/add-package"
                element={<AddPackage />}
              />
              <Route path="core-services" element={<AdminCoreServices />} />
              <Route
                path="core-services/add-service"
                element={<AddCoreService />}
              />
              <Route path="admin-settings" element={<AdminSettings />} />
            </Route>
          </Route>
          <Route path="/not-allowed" element={<NotAllowed />} />
          <Route path="/error" element={<OtherErrors />} />
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
